/* eslint-disable no-console */
/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import Modal from '../../containers/modal.jsx';
import styles from './LoginModal.css';

import Box from '../box/box.jsx';
import classnames from 'classnames';

import bgIMG from "./loginBG.png"
import lock from "./lock.svg"
import phone from "./phone.svg"
import { setSession } from '../../reducers/session.js';
import { connect } from 'react-redux';
import { UserApi } from '../../api/user.js';
import { MD5, SHA256 } from 'crypto-js';

// {
//     "hours": 12,
//     "status": "ok",
//     "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6Inpob3V3ZWkiLCJleHAiOjE2OTcwNjM2NjV9.13eGDrXC1bA0uBH4bCyf8ihRd1Tv1_0JMw7DmAnj-rs",
//     "user": {
//         "UserId": "zhouwei",
//         "Nick": "周老师",
//         "Email": "769479627@qq.com",
//         "Submit": 486,
//         "Solved": 146,
//         "Defunct": "N",
//         "Accesstime": "2023-10-05T13:29:00+08:00",
//         "Volume": 10,
//         "Avatar": "https://oj-1256154465.cos.ap-shanghai.myqcloud.com/wangpan/15vDgGWR_cfeb97daf245c01e824b6b909a22156.jpg",
//         "Language": 1,
//         "Password": "",
//         "Description": "",
//         "School": "pachong",
//         "UserRight": "AT",
//         "Ip": "",
//         "RegTime": "0001-01-01T00:00:00Z"
//     }
// }

function LoginModal(props) {
    const [showLoginModal, setShowLoginModal] = useState(props.session.reLogin)
    const [userID, setUserID] = useState("")
    const [password, setPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState(props.session.reLogin ? "登录已过期，请重新登录" : "")

    useEffect(() => {
        if (props.session.needLogin) {
            setShowLoginModal(true)
            setErrorMessage("此操作需要登录，请先登录")
            props.setSession({ needLogin: false })
        }
        if (props.session.logout) {
            setShowLoginModal(true)
            setErrorMessage("您已退出登录")
            props.setSession({ logout: false })
        }
    }, [props.session.needLogin, props.session.logout])

    const login = () => {
        setErrorMessage("正在登录中...")
        let psw = MD5(password).toString()
        UserApi.login({ userID, password: psw }).then(data => {
            console.log(data)
            if (data.status === "error") {
                setErrorMessage(data.msg)
            } else {
                setShowLoginModal(false);
                setPassword("")
                setErrorMessage("")
                localStorage.setItem("token", data.token)
                localStorage.setItem("user_id", data.user.user_id)
                localStorage.setItem("nick", data.user.nick)
                //存储 user for ipachong.com/exam
                localStorage.setItem("user", JSON.stringify(data.user))
                //超时锁不用存储

                props.setSession({
                    reLogin: false,
                    needLogin: false,
                    logout: false,
                    session: {
                        user: {
                            userID: data.user.user_id,
                            username: data.user.nick,
                            userInfo: data.user
                        }
                    }
                })
            }
        })
    }

    return (<>
        <div onClick={() => { setShowLoginModal(true) }} style={{ width: '100%', height: "100%", padding: '1rem 2rem' }}>登录</div>
        {showLoginModal && <Modal
            className={styles.modalContent}
            // contentLabel={"登录"}
            id="loginModal"
            onRequestClose={() => {
                setShowLoginModal(false);
                setPassword("")
                setErrorMessage("")
            }}
        >
            <div className={styles.loginBG} style={{ backgroundImage: `url(${bgIMG})` }}>
                <Box
                    className={styles.boxPadding}
                >
                    <div className={classnames(styles.inputBox, styles.inputPhone)} style={{ backgroundImage: `url(${phone})` }} >
                        <input
                            className={styles.minInput}
                            name="account"
                            placeholder="请输入手机号"
                            type="text"
                            defaultValue={userID}
                            onChange={(e) => { setUserID(e.target.value) }}
                        />
                    </div><br />
                    <div
                        className={classnames(styles.inputBox, styles.inputPwd)} style={{ backgroundImage: `url(${lock})` }}
                    >
                        <input
                            autoComplete='off'
                            className={styles.minInput}
                            name="password"
                            placeholder="请输入密码"
                            type="password"
                            defaultValue={password}
                            onChange={(e) => { setPassword(e.target.value) }}
                            onKeyUp={(e) => {
                                setErrorMessage(e.getModifierState('CapsLock') ? "大写锁定已打开" : "")
                                var key = window.event ? e.keyCode : e.which; //回车登录
                                if (key === 13) login()
                                return false
                            }}
                        />
                    </div><br />
                    <div className={styles.errorMessage}>{errorMessage}</div>
                    <div className={styles.btnSubmit} onClick={() => { login() }}>登录</div>
                </Box>
            </div >

        </Modal >}

    </>)
}

const mapStateToProps = states => ({
    session: states.session
})
const mapDispatchToProps = dispatch => ({
    setSession: (session) => dispatch(setSession(session))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginModal);
// export default LoginModal;
